import { CarSearchIcon } from './CarSearchIcon';

/**
 * author: tetzla
 * id 6BF272B9-40CF-45E8-8CE4-8E186BFE95BF
 * name car-search
 * version: 7.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/car-search.svg
 * tags
 * - Automotive 
 */
export const CarFindIcon = CarSearchIcon;
export default CarFindIcon